// 服务提供商，目地是解决组件项目可以使用外界的提供的服务
const serviceProvider = function() {

    var pri = {
        windowService: undefined,
        systemService: undefined,
        userService: undefined
    }

    var pub = {
        get windowService() {
            return pri.windowService
        },
        set windowService(value) {
            pri.windowService = value
        },

        get systemService() {
            return pri.systemService
        },
        set systemService(value) {
            pri.systemService = value
        },

        get userService() {
            return pri.userService
        },
        set userService(value) {
            pri.userService = value
        },

        get httpService() {
            return pri.httpService
        },
        set httpService(value) {
            pri.httpService = value
        }
    }

    return pub;
}

var service = serviceProvider();

export default service;